import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'user-temp-token';
const BASE_PATH_V2 = 'v2/user-temp-token';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async createByOsHash(body) {
    const url = mountUrl(`/${BASE_PATH_V2}`);
    return api.post(url, body);
  },
};
